import Vue from 'vue'
import Storage from 'vue-ls'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/permission'
import { Message, MessageBox, Notification, Loading, Icon, DatePicker,Rate,Tag,Dialog,Link, Progress, Checkbox, CheckboxButton, CheckboxGroup,
Select, Option, OptionGroup, Upload, Table, TableColumn, Pagination,Empty,Divider,Button,Card,
Input,InputNumber,Result,Popover,Switch,Alert,Descriptions,DescriptionsItem,Radio,RadioGroup,RadioButton} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

Vue.config.productionTip = false

const storageOptions = {
  namespace: 'pension_',
  name: 'ls',
  storage: 'local',
}
Vue.use(Storage, storageOptions)

locale.use(lang)
Vue.use(Loading)
Vue.use(Icon)
Vue.use(Link)
Vue.use(Switch)
Vue.use(Rate)
Vue.use(Tag)
Vue.use(Dialog)
Vue.use(DatePicker)
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Progress)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Upload)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Empty)
Vue.use(Divider);
Vue.use(Button);
Vue.use(InputNumber);
Vue.use(Input);
Vue.use(Result);
Vue.use(Popover);
Vue.use(Alert);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Card);
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$message = Message
Vue.prototype.$messageBox = MessageBox
Vue.prototype.$notification = Notification
Vue.prototype.$loading = Loading
Vue.prototype.$confirm = MessageBox.confirm;

new Vue({
  render: h => h(App),
	router,
  store
}).$mount('#app')
